import FormCampaing from '../../Organisms/FormCampaing/FormCampaing'
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle'

const CreateCampaing = () => {
  return (
    <div className="nd-grid main-home">
      <HeaderTitle headerText="Crear una campaña" withDivider />
      <div className="box s-pxy-20 m-pxy-50">
        <FormCampaing newCampaing />
      </div>
    </div>
  )
}

export default CreateCampaing
